import React, { useEffect, useState } from "react";
import PopularCourseCart from "./PopularCourseCart";
import PopularCourseCartAimation from "../../../PowerFullAnimation/PopularCourseCartAimation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointRight } from "@fortawesome/free-solid-svg-icons";
import { Slide } from "react-reveal";
import { Link } from "react-router-dom";




const PopularCourse = () => {
    const [course, setCourse] = useState([]);
    const [loaddig, setLoaddig] = useState(true);



    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/course/getAllCourse')
            .then(res => res.json())
            .then(data => {
                setCourse(data?.pCourseData);
                setLoaddig(false);
            })
            .catch(err => {
                setLoaddig(true)
            })
    }, [course])


    return (
        <div className="container-fluid p-5" style={{ borderRadius: "10px" }}>
            <div className="course-title text-center mt-5 mb-5">
                <div className="popular-title">
                    <Slide right>
                        <h3 className="fw-bold mb-2 fs-2">জনপ্রিয় কোর্সসমূহ</h3>
                        <h5 className="fs-4">পুরো অক্টোবর মাস জুড়ে টেন মিনিট স্কুলের বিভিন্ন কোর্স করা যাবে আরো সাশ্রয়ে!</h5>
                    </Slide>
                </div>
            </div>
            <div className="course-data">
                <div className="row gy-4">
                    {
                        course.map(course => <PopularCourseCart course={course} key={course._id} />)
                    }
                </div>
            </div>
            <div className="isLoading">
                {
                    loaddig ? <>

                        <PopularCourseCartAimation />
                        <div className="pot mt-3 mb-3" ></div>
                        <PopularCourseCartAimation />



                    </>


                        : ""
                }
            </div>
            <div className="morecourse text-center mt-4">
                <Link to='/skills'>
                    < button className="btn btn-primary fs-5"> স্কিল ডেভেলপমেন্টের সকল কোর্স দেখুন <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
                </Link>

            </div>
        </div >
    );
};

export default PopularCourse;